<app-pharm-header></app-pharm-header> 

<div class="issue-drug-container">
  <app-pharm-sidebar></app-pharm-sidebar>

  <div class="page-header">
    <h2>💊 Issue Drug to Patient</h2>
    <button class="open-modal-btn" (click)="showIssueModal = true">➕ New Issue</button>
  </div>

  <!-- Feedback -->
  <div class="feedback" *ngIf="successMessage || errorMessage">
    <div class="success" *ngIf="successMessage">{{ successMessage }}</div>
    <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>

  <!-- 🔹 Modal for Drug Issue Form -->
  <div class="modal-backdrop" *ngIf="showIssueModal">
    <div class="modal">
      <h3>💊 Issue Drug</h3>

      <form (ngSubmit)="submitIssue()" class="modal-form">
        <label>Store:</label>
        <div class="readonly-field">{{ selectedStoreName }}</div>
        <input type="hidden" [(ngModel)]="issue.store_id" name="store_id" />

        <label>Drug:</label>
        <select [(ngModel)]="issue.stock_item_id" name="stock_item_id" (change)="checkStockBalance()" required>
          <option [ngValue]="null">-- Select Drug --</option>
          <option *ngFor="let item of stockItems" [ngValue]="item.stock_item_id">
            {{ item.drug_name }} ({{ item.quantity }} {{ item.unit || 'units' }})
          </option>
        </select>

        <div *ngIf="stockBalance !== null" class="stock-alert">
          Available in store: <strong>{{ stockBalance }}</strong>
        </div>

        <label>Quantity:</label>
        <input type="number" [(ngModel)]="issue.quantity" name="quantity" required min="1" />

        <label>Patient Type:</label>
        <select [(ngModel)]="issue.patient_type" name="patient_type">
          <option value="in-patient">In-Patient</option>
          <option value="out-patient">Out-Patient</option>
        </select>

        <label>Search Patient:</label>
        <input type="text" [(ngModel)]="searchPatient" (input)="filterPatients()" placeholder="Search..." name="search" />

        <label>Select Patient:</label>
        <select [(ngModel)]="issue.patient_id" name="patient_id" required>
          <option [ngValue]="null">-- Select Patient --</option>
          <option *ngFor="let patient of filteredPatients" [ngValue]="patient.id">
            {{ patient.surname }} {{ patient.other_names }} ({{ patient.type }})
          </option>
        </select>

        <label>Note (optional):</label>
        <input type="text" [(ngModel)]="issue.note" name="note" />

        <div class="modal-actions">
          <button type="submit" [disabled]="isSubmitting">{{ isSubmitting ? 'Processing...' : 'Issue Drug' }}</button>
          <button type="button" class="cancel" (click)="showIssueModal = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <hr />

  <h3>📝 Recent Drug Issues</h3>

  <!-- 🔍 Filters -->
  <div class="filters">
    <input type="text" [(ngModel)]="filters.drug" (ngModelChange)="currentPage = 1" placeholder="Filter by Drug" />
    <input type="text" [(ngModel)]="filters.patient" (ngModelChange)="currentPage = 1" placeholder="Filter by Patient" />
    <select [(ngModel)]="filters.type" (ngModelChange)="currentPage = 1">
      <option value="">All Types</option>
      <option value="in-patient">In-Patient</option>
      <option value="out-patient">Out-Patient</option>
    </select>
    <input type="text" [(ngModel)]="filters.store" (ngModelChange)="currentPage = 1" placeholder="Filter by Store" />
    <input type="number" [(ngModel)]="filters.quantity" (ngModelChange)="currentPage = 1" placeholder="Exact Quantity" />
    <input type="date" [(ngModel)]="filters.date" (ngModelChange)="currentPage = 1" />
  </div>

  <div *ngIf="loadingIssues">⏳ Loading recent issues...</div>

  <table *ngIf="!loadingIssues && filteredIssues().length > 0">
    <thead>
      <tr>
        <th>Drug</th>
        <th>Patient</th>
        <th>Type</th>
        <th>Store</th>
        <th>Quantity</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let issue of paginatedIssues()">
  <td><span class="label">Drug:</span> {{ issue.stock_item_name }}</td>
  <td><span class="label">Patient:</span> {{ issue.patient_name }}</td>
  <td><span class="label">Type:</span> {{ issue.patient_type }}</td>
  <td><span class="label">Store:</span> {{ issue.store_name }}</td>
  <td><span class="label">Quantity:</span> {{ issue.quantity }}</td>
  <td><span class="label">Date:</span> {{ issue.created_at | date: 'short' }}</td>
</tr>

    </tbody>
  </table>

  <div class="pagination">
    <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">⬅️</button>
    Page {{ currentPage }}
    <button (click)="currentPage = currentPage + 1" [disabled]="currentPage * pageSize >= filteredIssues().length">➡️</button>
  </div>
</div>
